import { STSchemeColorVal } from '@tencent/slide-sdk-model';
import { IColorStyle } from '../../Interface/chart-v3/chart-properties.interface';

export enum ColorStyleMethodEnum {
    cycle = 'STColorStyleMethodEnum_cycle',
    withinLinear = 'STColorStyleMethodEnum_withinLinear',
    withinLinearReversed = 'STColorStyleMethodEnum_withinLinearReversed',
}

const colorfulPalette1: IColorStyle = {
    id: '10',
    schemeClrs: [
        STSchemeColorVal.accent1,
        STSchemeColorVal.accent2,
        STSchemeColorVal.accent3,
        STSchemeColorVal.accent4,
        STSchemeColorVal.accent5,
        STSchemeColorVal.accent6,
    ],
    variations: [
        {},
        { lumMod: 60000 },
        { lumMod: 80000, lumOff: 20000 },
        { lumMod: 80000 },
        { lumMod: 60000, lumOff: 40000 },
        { lumMod: 50000 },
        { lumMod: 70000, lumOff: 30000 },
        { lumMod: 70000 },
        { lumMod: 50000, lumOff: 50000 },
    ],
    meth: ColorStyleMethodEnum.cycle,
};
const colorfulPalette2: IColorStyle = {
    id: '11',
    schemeClrs: [STSchemeColorVal.accent1, STSchemeColorVal.accent3, STSchemeColorVal.accent5],
    variations: [
        {},
        { lumMod: 60000 },
        { lumMod: 80000, lumOff: 20000 },
        { lumMod: 80000 },
        { lumMod: 60000, lumOff: 40000 },
        { lumMod: 50000 },
        { lumMod: 70000, lumOff: 30000 },
        { lumMod: 70000 },
        { lumMod: 50000, lumOff: 50000 },
    ],
    meth: ColorStyleMethodEnum.cycle,
};
const colorfulPalette3: IColorStyle = {
    id: '12',
    schemeClrs: [STSchemeColorVal.accent2, STSchemeColorVal.accent4, STSchemeColorVal.accent6],
    variations: [
        {},
        { lumMod: 60000 },
        { lumMod: 80000, lumOff: 20000 },
        { lumMod: 80000 },
        { lumMod: 60000, lumOff: 40000 },
        { lumMod: 50000 },
        { lumMod: 70000, lumOff: 30000 },
        { lumMod: 70000 },
        { lumMod: 50000, lumOff: 50000 },
    ],
    meth: ColorStyleMethodEnum.cycle,
};
const colorfulPalette4: IColorStyle = {
    id: '13',
    schemeClrs: [STSchemeColorVal.accent6, STSchemeColorVal.accent5, STSchemeColorVal.accent4],
    variations: [
        {},
        { lumMod: 60000 },
        { lumMod: 80000, lumOff: 20000 },
        { lumMod: 80000 },
        { lumMod: 60000, lumOff: 40000 },
        { lumMod: 50000 },
        { lumMod: 70000, lumOff: 30000 },
        { lumMod: 70000 },
        { lumMod: 50000, lumOff: 50000 },
    ],
    meth: ColorStyleMethodEnum.cycle,
};

const monochromaticPalette1: IColorStyle = {
    id: '14',
    schemeClrs: [STSchemeColorVal.accent1],
    meth: ColorStyleMethodEnum.withinLinear,
};
const monochromaticPalette2: IColorStyle = {
    id: '15',
    schemeClrs: [STSchemeColorVal.accent2],
    meth: ColorStyleMethodEnum.withinLinear,
};
const monochromaticPalette3: IColorStyle = {
    id: '16',
    schemeClrs: [STSchemeColorVal.accent3],
    meth: ColorStyleMethodEnum.withinLinear,
};
const monochromaticPalette4: IColorStyle = {
    id: '17',
    schemeClrs: [STSchemeColorVal.accent4],
    meth: ColorStyleMethodEnum.withinLinear,
};
const monochromaticPalette5: IColorStyle = {
    id: '18',
    schemeClrs: [STSchemeColorVal.accent5],
    meth: ColorStyleMethodEnum.withinLinear,
};
const monochromaticPalette6: IColorStyle = {
    id: '19',
    schemeClrs: [STSchemeColorVal.accent6],
    meth: ColorStyleMethodEnum.withinLinear,
};
const monochromaticPalette7: IColorStyle = {
    id: '20',
    schemeClrs: [STSchemeColorVal.dk1],
    meth: ColorStyleMethodEnum.cycle,
    variations: [
        { tint: 88500 },
        { tint: 55000 },
        { tint: 75000 },
        { tint: 98500 },
        { tint: 30000 },
        { tint: 60000 },
        { tint: 80000 },
    ],
};
const monochromaticPalette8: IColorStyle = {
    id: '21',
    schemeClrs: [STSchemeColorVal.accent1],
    meth: ColorStyleMethodEnum.withinLinearReversed,
};
const monochromaticPalette9: IColorStyle = {
    id: '22',
    schemeClrs: [STSchemeColorVal.accent2],
    meth: ColorStyleMethodEnum.withinLinearReversed,
};
const monochromaticPalette10: IColorStyle = {
    id: '23',
    schemeClrs: [STSchemeColorVal.accent3],
    meth: ColorStyleMethodEnum.withinLinearReversed,
};
const monochromaticPalette11: IColorStyle = {
    id: '24',
    schemeClrs: [STSchemeColorVal.accent4],
    meth: ColorStyleMethodEnum.withinLinearReversed,
};
const monochromaticPalette12: IColorStyle = {
    id: '25',
    schemeClrs: [STSchemeColorVal.accent5],
    meth: ColorStyleMethodEnum.withinLinearReversed,
};
const monochromaticPalette13: IColorStyle = {
    id: '26',
    schemeClrs: [STSchemeColorVal.accent6],
    meth: ColorStyleMethodEnum.withinLinearReversed,
};

export const presetColorPalettes = {
    colorful: [colorfulPalette1, colorfulPalette2, colorfulPalette3, colorfulPalette4],
    monochromatic: [
        monochromaticPalette1,
        monochromaticPalette2,
        monochromaticPalette3,
        monochromaticPalette4,
        monochromaticPalette5,
        monochromaticPalette6,
        monochromaticPalette7,
        monochromaticPalette8,
        monochromaticPalette9,
        monochromaticPalette10,
        monochromaticPalette11,
        monochromaticPalette12,
        monochromaticPalette13,
    ],
};

export function findChartColorPaletteById(colorPaletteId) {
    const colorPalette = [
        ...presetColorPalettes.colorful, ...presetColorPalettes.monochromatic]
        .find(palette => palette.id === colorPaletteId);
    return colorPalette || presetColorPalettes.colorful[0];
}

export function getMonochromaticPaletteVariations(total) {
    // shade变换数列，tint与之对应
    //  3: 65
    //  5: 53 76
    //  7: 47 65 82
    //  9: 44 58 72 86
    // 11: 41 53 65 76 88
    // 上面数组中第n项为100 - step * (n + 1), 观察得知数组中间项为65
    // 输入N时， 则数组长度为 (N - 1) / 2, 中间项index为 ((N - 1) / 2 - 1) / 2
    //  100 - step * (((N - 1) / 2 - 1) / 2 + 1) = 65
    let variations;
    const step = 70 / (((total - 1) / 2) + 1);
    const half = Math.floor(total / 2);
    const variationNums = Array(half).fill('')
        .map((_, i) => 30 + ((i + 1) * step));
    if (total % 2) {
        // 奇数
        variations = [
            ...variationNums.map(i => ({ shade: Math.floor(i) * 1000 })),
            {},
            ...variationNums.reverse().map(i => ({ tint: Math.ceil(i) * 1000 })),
        ];
    } else {
        // 偶数
        variations = [
            ...variationNums.map(i => ({ shade: Math.floor(i) * 1000 })),
            ...variationNums.reverse().map(i => ({ tint: Math.ceil(i) * 1000 })),
        ];
    }
    return variations;
}

